import { useEffect, useRef } from 'react';
import { Client } from '@stomp/stompjs';
import SockJS from 'sockjs-client';
import { useQueryClient } from '@tanstack/react-query';
import { useAuthStore } from '../auth/store';

export function useDashboardWs() {
  const queryClient = useQueryClient();
  const clientRef = useRef<Client | null>(null);

  useEffect(() => {
    const token = useAuthStore.getState().accessToken;
    if (!token) return;
    const url = `/ws?token=${encodeURIComponent(token)}`;
    const client = new Client({
      webSocketFactory: () => new SockJS(url),
      connectHeaders: { Authorization: `Bearer ${token}` },
      reconnectDelay: 4000,
      heartbeatIncoming: 10000,
      heartbeatOutgoing: 10000,
      onConnect: () => {
        client.subscribe('/topic/access-events', (msg) => {
          try {
            const evt = JSON.parse(msg.body);
            queryClient.setQueryData(['recent-events'], (old: unknown[] | undefined) => {
              const list = Array.isArray(old) ? old : [];
              return [{ ...evt, _local: true }, ...list].slice(0, 50);
            });
            queryClient.invalidateQueries({ queryKey: ['inside-now'] });
          } catch (e) {
            console.warn('parse error', e);
          }
        });
        client.subscribe('/topic/dashboard-kpis', (msg) => {
          try { queryClient.setQueryData(['kpis'], JSON.parse(msg.body)); }
          catch (e) { console.warn(e); }
        });
      },
    });
    client.activate();
    clientRef.current = client;
    return () => { client.deactivate(); };
  }, [queryClient]);

  return clientRef;
}
